"use strict";

function setText(xml, text) {
  if (xml.childNodes[0]) {
    xml.removeChild(xml.childNodes[0]);
  }
  xml.appendChild(xml.ownerDocument.createTextNode(text));
}
function getText(xml) {
  if (xml.childNodes.length === 0) {
    return "";
  }
  return xml.childNodes[0].nodeValue;
}
function replaceTagName(myChartXml, xml, name1, name2) {
  var start = xml.getElementsByTagName(name1)[0];
  var replaced = myChartXml.createElement(name2);
  var index;

  // Copy the children
  while (start.firstChild) {
    replaced.appendChild(start.firstChild); // *Moves* the child
  }

  // Copy the attributes
  for (index = start.attributes.length - 1; index >= 0; --index) {
    replaced.attributes.setNamedItem(start.attributes[index].cloneNode());
  }

  // Replace it
  start.parentNode.replaceChild(replaced, start);
}
function insertAfter(newNode, existingNode) {
  existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
}
function drop(xml) {
  xml.parentNode.removeChild(xml);
}
function dropAllChildren(xml) {
  while (xml.childNodes.length > 0) {
    xml.removeChild(xml.childNodes[0]);
  }
}
function ensureDirectChild(xml, childName) {
  for (var _len = arguments.length, otherNames = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    otherNames[_key - 2] = arguments[_key];
  }
  if (childName instanceof Array) {
    return childName.map(function (cName) {
      return ensureDirectChild.apply(void 0, [xml, cName].concat(otherNames));
    });
  }
  for (var i = 0, len = xml.childNodes.length; i < len; i++) {
    var _child = xml.childNodes[i];
    if (_child.tagName === childName) {
      if (otherNames.length > 0) {
        return ensureDirectChild.apply(void 0, [_child].concat(otherNames));
      }
      return _child;
    }
  }
  var child = xml.ownerDocument.createElement(childName);
  xml.insertBefore(child, xml.childNodes[0]);
  if (otherNames.length > 0) {
    return ensureDirectChild.apply(void 0, [child].concat(otherNames));
  }
  return child;
}
function getFirstElement(xml) {
  for (var _len2 = arguments.length, names = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    names[_key2 - 1] = arguments[_key2];
  }
  if (names.length === 1) {
    return xml.getElementsByTagName(names[0])[0];
  }
  return names.map(function (name) {
    return xml.getElementsByTagName(name)[0];
  });
}
function setAttributes(xml, attributes) {
  Object.keys(attributes).forEach(function (key) {
    var attr = attributes[key];
    if (typeof attr === "function") {
      attr = attr(xml.getAttribute(key));
    }
    xml.setAttribute(key, attr);
  });
  return xml;
}
module.exports = {
  getFirstElement: getFirstElement,
  dropAllChildren: dropAllChildren,
  ensureDirectChild: ensureDirectChild,
  setText: setText,
  getText: getText,
  replaceTagName: replaceTagName,
  insertAfter: insertAfter,
  setAttributes: setAttributes,
  drop: drop
};